module.exports = __webpack_public_path__ + "static/img/a06.6f4585e8.jpg";